import LinkedInTag from 'react-linkedin-insight';

export const logLinkedInConversion = (conversionId : string) => {
    const PartnerID: string = '4990732'
    const disabled = false
    LinkedInTag.init(PartnerID, 'dc', disabled);
    LinkedInTag.track(conversionId)
}
